module.exports = __webpack_public_path__ + "static/media/calculator-result-under-age-5.eac6d3ee.jpg";